import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDetailedStockArgs = {
  booking: string;
  dispatcherTaxId: string;
};

type GetDetailedStockResponse = {
  state: number;
  value: { mensaje: string; contenedor: string; ok: boolean }[];
};

export const generateANPBooking = async ({
  booking,
  dispatcherTaxId,
}: GetDetailedStockArgs): Promise<GetDetailedStockResponse> => {
  try {
    const res = await apiClient.post<GetDetailedStockResponse>(
      Endpoints.ANPBooking,
      {
        booking,
        rut: dispatcherTaxId,
      }
    );
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
